import CopySpec from "./CopySpec";
export default CopySpec;
